import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-crunchyroll',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Crunchyroll icon</title><path d="M2.933 13.467a10.55 10.55 0 1 1 21.067-.8V12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12h.8a10.617 10.617 0 0 1-9.867-10.533zM19.2 14a3.85 3.85 0 0 1-1.333-7.467A7.89 7.89 0 0 0 14 5.6a8.4 8.4 0 1 0 8.4 8.4 6.492 6.492 0 0 0-.133-1.6A3.415 3.415 0 0 1 19.2 14z"/></svg>`,
    styles: []
})
export class SimpleIconsCrunchyrollComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#F47521';
    @Input() className: string = 'simple-icons-crunchyroll'
    constructor() {}
    ngOnInit(): void {}
}
